import MeetingItem from '../../components/meetingItem';


import './style.scss';
import {useEffect, useState} from "react";
import {getMeetingsByGroup} from "../../API/apiService";
import {Link, useLocation} from "react-router-dom";

function MeetingsList() {

    // HOOKS
    const location = useLocation();
    console.log('group '+location.state?.group);
    const receivedGroup = location.state?.group;
    const [meetings, setMeetings] = useState([]);
    async function getInfo(){
        if(receivedGroup) {
            const m = await getMeetingsByGroup(receivedGroup);
            setMeetings(m);
        }
    }

    // pasar grupo  y moAREeloo

    useEffect(() => {
        getInfo()
    }, []);
    return (
        <section className='meetings'>
            <div className='meetings__main group'>
                <div className='group__info info'>
                    <div className='info__icon icon'>
                        <span className='material-symbols-rounded icon__img'>school</span>
                    </div>
                    <span className='info__title'>Tomar asistencia</span>
                    <span className='info__value'>Lista de Encuentros</span>
                </div>

                <Link
                    className='group__btn btn'
                    to={'/escuelas'}>
                    <span className='material-symbols-rounded btn__icon'>
                      school
                    </span>
                    <span className='btn__text'>Escuelas</span>
                </Link>

            </div>

            <div className='meetings__details'>
                {meetings && meetings?.length > 0 &&
                    meetings.map((meeting, i) => (
                        <MeetingItem key={i} meeting={meeting}/>
                    ))}
            </div>
        </section>
    );
}

export default MeetingsList;